<template>
  <a-spin :spinning="loading" tip="در حال ثبت اطلاعات">
    <a-list :locale="{emptyText:'رکوردی وجود ندارد.'}" bordered item-layout="horizontal">
      <a-list-item class="grid grid-cols-3" v-for="(item,index) in writ" :key="index">
        <div>
          <a-tooltip placement="bottomRight">
            <a-button v-if="item.file" target="_blank" type="primary" :href="item.file.storage" class="mr-3">
              دانلود
              پیوست
            </a-button>
            <template slot="title">
              <span>حذف</span>
            </template>
            <a-popconfirm :disabled="!$getAccess('personnel.rule.delete')"
                          placement="right"
                          title="آیا می خواهید حذف کنید؟"
                          ok-text="بله"
                          cancel-text="خیر"
                          @confirm="removeDocs(item)"
            >
              <a-button type="danger" class="mr-3">حذف</a-button>

            </a-popconfirm>

          </a-tooltip>
        </div>
        <div style="direction: rtl"><span>نوع :</span><span>{{ item.type_str }}</span></div>
        <div style="direction: rtl">عنوان : {{ item.note }}</div>
      </a-list-item>
    </a-list>
    <a-button :disabled="!$getAccess('personnel.rule.create')" class="mt-4 ml-2"
              @click="showAddDocument=true;isAlertUpload = false">افزودن ردیف
    </a-button>


    <a-modal okText="ایجاد" cancelText="بستن" forceRender v-model="showAddDocument" title="افزودن سند"
             @ok="addDocs">
      <a-form :form="fromDocs">

        <a-form-item label="نوع" has-feedback>

          <a-select
              v-decorator="['type']"
              placeholder="انتخاب نوع"
          >
            <a-select-option value="1">
              حکم
            </a-select-option>
            <a-select-option value="2">
              اخطار
            </a-select-option>
            <a-select-option value="3">
              پاداش
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="شرح">

          <input class="ant-input" style="width:100%"
                 autocomplete="off"
                 v-decorator="['note']"
          />
        </a-form-item>
        <a-form-item label="فایل">
          <div class="dropbox">
            <a-upload-dragger
                v-if="!isAlertUpload"
                :customRequest="uploadImage"
                :show-upload-list="false"
                :before-upload="beforeUpload"
            >
              <p class="ant-upload-drag-icon">
                <a-icon type="inbox"/>
              </p>
              <p class="ant-upload-text">
                فایل را درگ کنید یا اینکه کاوش کنید.
              </p>
              <p class="ant-upload-hint">
                تصویر که بارگذاری می کنید باید زیر ۵ مگابایت باشد.
              </p>
            </a-upload-dragger>
            <div v-else>
              <a-alert message="آپلود سند با موفقیت انجام شد." type="success"/>
            </div>
          </div>
        </a-form-item>
      </a-form>

    </a-modal>
  </a-spin>
</template>

<script>
import axios from "@/axios";

export default {
  name: "writs",
  props: {
    writ: Array,
    uploadImage: Function,
    beforeUpload: Function,
    value: [Object,null]
  },
  data() {
    return {
      loading: false,
      showAddDocument: false,
      isAlertUpload: false,
      fromDocs: this.$form.createForm(this, {name: 'fromDocs'}),
    }
  },
  computed: {
    id() {
      return this.$route.params.id
    }
  },
  methods: {
    async removeDocs(item) {
      if (item.id) {
        try {
          await axios.post('/personnel/remove-writ', {id: item.id});
          await this.$emit('update')
        } catch (e) {
           console.log(e);
        }
      } else {
        const index = this.writ.indexOf(item);
        this.writ.splice(index, 1);
      }
    },
    addDocs(e) {
      e.preventDefault();
      this.fromDocs.validateFields(async(err, values) => {
        if (!err) {
          let writ = this.writ
          if (this.value) {
            values.file_id = this.value.id
            values.file = this.value.storage
          }
          writ.push(values);
          this.showAddDocument = false;
          this.$message.success('اطلاعات با موفقیت ثبت شد');
          this.fromDocs.resetFields();
          this.$emit('input',null)
          await this.saveData(writ);
        } else {
          this.$ntGetError('اطلاعات را به صورت کامل وارد کنید');
        }
      });
    },
    async saveData(writ) {
      if (writ) {
        try {
          this.loading = true
          let values = {
            writ: writ,
            id: this.id
          }
          values.documents = this.documents;
          if (!this.$getAccess('personnel.train')) {
            values.writ = this.writ
          }
          await axios.post('/personnel/writ/update', values);
          this.$emit('update')
          this.$ntSet()
        } catch (e) {
          this.$ntSetError()

      console.log(e)
        } finally {
          this.loading = false
          this.showAddEducationalInformation = false
        }
      }
      else {
        this.$ntGetError('اطلاعات را به صورت کامل وارد کنید');
      }
    },
  },
}
</script>

<style scoped>

</style>